export enum AuthQueryParams {
  //query params used in webauth login flow in marketing pages
  FLOW = 'flow',
  EMAIL = 'webauthemail',

  //deeplink query params received from the app for webauth login
  LOGIN_TOKEN = 'login_token',
  DEVICE_TYPE_ID = 'devicetypeid',
  REDIRECT_URI = 'redirect_uri',
  HEADLESS = 'headless',

  //internal flag set by WebauthRedirectComponent when redirect_uri fails validation; consumed on /login-webauth
  REDIRECT_URI_INVALID = 'redirect_uri_invalid',

  //deeplink query params to send back to app after login
  ACCESS_TOKEN = 'access_token',
  ACCESS_SECRET = 'access_secret',
  UID = 'uid',
  WEB_DEVICE_ID = 'web_device_id',
  USERNAME = 'username_b64',
  ENC_KEY = 'enc_key',
  SIGNATURE = 'signature', //added by sync.crypt service to verify the response is from our webapp
  SECRET_ENC = 'secret_enc', //added by sync.crypt service to verify the response is from our webapp
  TIMESTAMP = 'timestamp', //added by sync.crypt service for replay protection
}
